import React from "react"
import axios from 'axios'
import { MDCLinearProgress } from '@material/linear-progress';
import $ from "jquery";
import { MDCDataTable } from '@material/data-table';

function getBalance() {

  function roundPlus(number) { if (isNaN(number)) return false; var m = Math.pow(10, 2); return Math.round(number * m) / m; }

  function insertPrefixZero(num) {
    num = String(num)
    if (num.length == 1)
      return "0" + num
    return num
  }

  function timestampToHuman(timestamp) { 
    var d = new Date(timestamp)
    return `${insertPrefixZero(d.getDate())}.${insertPrefixZero(d.getMonth() + 1)}.${insertPrefixZero(d.getFullYear())} ${insertPrefixZero(d.getHours())}:${insertPrefixZero(d.getMinutes())}`
  }

  axios.get("https://nakrutkatop.com:443/api/cabinet", { withCredentials: true })
    .then(res => {
      setTimeout(() => {
        try {
          document.getElementById("main-content").style.opacity = 1
          document.getElementById("main-content").style.visibility = "visible"
        } 
        catch { }
      }, 50)
      document.querySelector(".ibalance").innerHTML = roundPlus(res.data.balance) + "$"
      var history = res.data.history
      console.log(res.data)
      var html = ""
      history.map(e => {
        html += `
      <tr class="mdc-data-table__row">
      <td class="mdc-data-table__cell"><span class="material-icons" style="color: ${e.type == "deposit" ? "#41c300" : "#D10000"}; vertical-align: middle; font-size: 30px;">
${e.type == "deposit" ? "keyboard_arrow_up" : "keyboard_arrow_down"}
</span> ${e.type == "deposit" ? "Пополнение" : "Списание"}</td>
      <td class="mdc-data-table__cell mdc-data-table__cell--numeric" data-toggle="tooltip" data-placement="bottom" title="${e.descr}">
        ${e.service}
      </td>
      <td class="mdc-data-table__cell mdc-data-table__cell--numeric">
      ${e.amount}$
      </td>
      <td class="mdc-data-table__cell">${timestampToHuman(e.timestamp)}</td>
    </tr>`})

      document.querySelector("#historyTable").innerHTML = html
    

    }
    )
}

class CabinetPage extends React.Component {

  componentDidMount() {
    const dataTable = new MDCDataTable(document.querySelector('.mdc-data-table'));
    getBalance()
  }

  render(props) {
    
    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      <main className="main-content" id="main-content" style={{ opacity: "0", visibility: "hidden", transition: ".3s opacity, .3s visibility" }}>

        <h2 className="pageHeader">Кабинет</h2>

        <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>

          <div className="ibox" style={{ margin: "0 24px 24px 0", maxWidth: "200px" }}>
            <h3 className="ibox_title">Ваш баланс</h3>
            <div className="ibox_content">
              <div className="ibalance">
              </div>
              <button data-toggle="modal" data-target="#payinModal" className="mdc-button mdc-button--raised" style={{ borderRadius: "6px", width: "100%" }}>
                <div className="mdc-button__ripple" style={{ borderRadius: "6px" }}></div>
                <i className="fas fa-angle-up fa-lg" style={{ color: "#fff", marginRight: "8px" }}></i>
                <span className="mdc-button__label">Пополнить</span>
              </button>
            </div>
          </div>

        </div>
        <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>

          <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%" }}>
            <h3 className="ibox_title">История операций</h3>
            <div className="ibox_content" style={{ padding: "0" }}>
              <div className="historyTable">
                <div class="mdc-data-table" style={{ width: "100%" }}>
                  <table class="mdc-data-table__table" aria-label="Dessert calories">
                    <thead>
                      <tr class="mdc-data-table__header-row">
                        <th
                          class="mdc-data-table__header-cell mdc-data-table__header-cell--with-sort"
                          role="columnheader"
                          scope="col"
                          aria-sort="none"
                          data-column-id="dessert"
                        >
                          <div class="mdc-data-table__header-cell-wrapper">
                            <div class="mdc-data-table__header-cell-label">
                              Операция
            </div>
                            <button class="mdc-icon-button material-icons mdc-data-table__sort-icon-button"
                              aria-label="Sort by dessert" aria-describedby="dessert-status-label">arrow_upward</button>
                            <div class="mdc-data-table__sort-status-label" aria-hidden="true" id="dessert-status-label">
                            </div>
                          </div>
                        </th>
                        <th
                          class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort mdc-data-table__header-cell--sorted"
                          role="columnheader"
                          scope="col"
                          aria-sort="ascending"
                          data-column-id="carbs"
                        >
                          <div class="mdc-data-table__header-cell-wrapper">
                            <button class="mdc-icon-button material-icons mdc-data-table__sort-icon-button"
                              aria-label="Sort by carbs" aria-describedby="carbs-status-label">arrow_upward</button>
                            <div class="mdc-data-table__header-cell-label">
                              Сервис
            </div>
                            <div class="mdc-data-table__sort-status-label" aria-hidden="true" id="carbs-status-label"></div>
                          </div>
                        </th>
                        <th
                          class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort"
                          role="columnheader"
                          scope="col"
                          aria-sort="none"
                          data-column-id="protein"
                        >
                          <div class="mdc-data-table__header-cell-wrapper">
                            <button class="mdc-icon-button material-icons mdc-data-table__sort-icon-button"
                              aria-label="Sort by protein" aria-describedby="protein-status-label">arrow_upward</button>
                            <div class="mdc-data-table__header-cell-label">
                              Сумма
            </div>
                            <div class="mdc-data-table__sort-status-label" aria-hidden="true" id="protein-status-label"></div>
                          </div>
                        </th>
                        <th
                          class="mdc-data-table__header-cell"
                          role="columnheader"
                          scope="col"
                          data-column-id="comments"
                        >
                          Дата и время
        </th>
                      </tr>
                    </thead>
                    <tbody class="mdc-data-table__content" id="historyTable" style={{ height: "100%" }}>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>


        </div>
      </main>
    </div>
  }
}

export default CabinetPage